/**
 * RadioButtonSelect
 */
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import { Typography } from '../Typography';
import { useTheme } from '../../';
import React from 'react';
export function RadioButtonSelectField(props) {
    const onChange = (event, value) => {
        if (props.coerceToBoolean) {
            if (value === 'true') {
                props.input.onChange(true);
            }
            else if (value === 'false') {
                props.input.onChange(false);
            }
        }
        else {
            props.input.onChange(value);
        }
    };
    const options = props.options || [];
    const theme = useTheme();
    return (React.createElement(Box, { mt: 2 },
        React.createElement(FormControl, { component: "fieldset", fullWidth: true },
            React.createElement(FormLabel, { component: "legend" },
                React.createElement(Typography, { variant: "body2" }, props.label)),
            React.createElement(RadioGroup, { row: true, onChange: onChange, value: `${props.input.value}` }, (options || []).map(opt => {
                return (React.createElement(FormControlLabel, { label: opt.label, value: `${opt.value}`, key: opt.label, style: { width: `calc(${100 / options.length}% - ${theme.spacing(2)}px)` }, control: React.createElement(Radio, { name: opt.label }) }));
            })))));
}
//# sourceMappingURL=RadioButtonSelectField.js.map